<template>
    <b-modal
        ref="modal-photo-edit"
        no-fade
        hide-footer
        id="modal-photo-edit"
        @shown="loadPhotoEditor"
    >
        <template v-slot:modal-header class="test">
            {{ $t("Editing") }} {{ img.file_name }}
            <div class="modal-saving-information">
                <b-spinner
                    :label="$t('Saving...')"
                    variant="primary"
                    v-show="saving"
                ></b-spinner>
                <span v-show="!saving"
                    ><strong>{{ $t("Last saved") }}:</strong>
                    {{ lastSaved }}</span
                >
            </div>
            <div class="modal-controls">
                <b-button variant="danger" class="mr-2" @click="hide">{{
                    $t("Close")
                }}</b-button>
                <b-button
                    variant="primary"
                    :disabled="saving"
                    @click="savePhoto"
                    >{{ $t("Save image") }}</b-button
                >
            </div>
        </template>
        <div class="fill-height">
            <div id="tui-image-editor" ref="image-editor"></div>
        </div>
    </b-modal>
</template>

<script>
import axios from "axios";
import moment from "moment";

// Load Image Editor
import "tui-image-editor/dist/tui-image-editor.css";
import "tui-color-picker/dist/tui-color-picker.css";

const ImageEditor = require("tui-image-editor");
const icona = require("tui-image-editor/dist/svg/icon-a.svg");
const iconb = require("tui-image-editor/dist/svg/icon-b.svg");
const iconc = require("tui-image-editor/dist/svg/icon-c.svg");
const icond = require("tui-image-editor/dist/svg/icon-d.svg");
const blackTheme = {
  "menu.normalIcon.path": icond,
  "menu.activeIcon.path": iconb,
  "menu.disabledIcon.path": icona,
  "menu.hoverIcon.path": iconc,
  "submenu.normalIcon.path": icond,
  "submenu.activeIcon.path": iconb,
  "loadButton.display": "none",
  "downloadButton.display": "none"
};

export default {
  name: "PhotoEditor",
  data() {
    return {
      saving: false,
      img: null,
      editorInstance: null
    };
  },
  computed: {
    lastSaved() {
      return moment(this.img.updated).format("YYYY-MM-DD HH:mm");
    }
  },
  methods: {
    show(img) {
      this.img = img;
      this.$refs["modal-photo-edit"].show();
    },
    hide() {
      this.$refs["modal-photo-edit"].hide();
    },
    loadPhotoEditor() {
      this.editorInstance = new ImageEditor(this.$refs["image-editor"], {
        useDefaultUI: true,
        includeUI: {
          loadImage: {
            path: this.img.url + "?t" + new Date().getTime(),
            name: this.img.file_name,
            crossOrigin: "anonymous"
          },
          theme: blackTheme, // or whiteTheme
          initMenu: "shape",
          menuBarPosition: "bottom",
          menu: ["shape", "crop", "icon", "rotate"]
        },
        cssMaxWidth: 1000,
        cssMaxHeight: 600,
        selectionStyle: {
          cornerSize: 20,
          rotatingPointOffset: 70
        }
      });
    },
    savePhoto() {
      this.saving = true;

      let fd = new FormData();
      fd.append(
        "photo",
        this.base64ToBlob(
          this.editorInstance.toDataURL({
            format: this.img.file_type.split("/").pop(),
            quality: 0.9
          })
        )
      );
      axios({
        method: "post",
        url: `/api/file-manager/${this.img.id}/edit-photo`,
        data: fd,
        headers: {
          "Content-Type": "multipart/form-data"
        }
      })
        .then(r => {
          this.img = r.data.data;
          this.$emit("saved", this.img);
        })
        .finally(() => {
          this.saving = false;
        });
    },
    base64ToBlob(data) {
      var rImageType = /data:(image\/.+);base64,/;
      var mimeString = "";
      var raw = void 0,
        uInt8Array = void 0,
        i = void 0;

      raw = data.replace(rImageType, function(header, imageType) {
        mimeString = imageType;

        return "";
      });

      raw = atob(raw);
      var rawLength = raw.length;
            uInt8Array = new Uint8Array(rawLength); // eslint-disable-line

      for (i = 0; i < rawLength; i += 1) {
        uInt8Array[i] = raw.charCodeAt(i);
      }

      return new Blob([uInt8Array], { type: mimeString });
    }
  }
};
</script>
